var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.$style.methodButton,attrs:{"href":"#","role":"button","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_c(_vm.buttonName,{tag:"Component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }